"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectShareRecommendationData = exports.selectSendRecommendationStatues = exports.isEmailInputShown = void 0;
var isEmailInputShown = function isEmailInputShown(state) {
  return state.drools.shareRecommendation.isShareEnabled;
};
exports.isEmailInputShown = isEmailInputShown;
var selectSendRecommendationStatues = function selectSendRecommendationStatues(state) {
  return {
    error: state.drools.shareRecommendation.error,
    isSent: state.drools.shareRecommendation.isSent
  };
};
exports.selectSendRecommendationStatues = selectSendRecommendationStatues;
var selectShareRecommendationData = function selectShareRecommendationData(state) {
  return state.drools.shareRecommendation.data;
};
exports.selectShareRecommendationData = selectShareRecommendationData;